import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OutlineButtonComponent } from "../outline-button/outline-button.component";
import { FullButtonComponent } from "../full-button/full-button.component";

@Component({
  selector: 'app-delete-confirmation',
  standalone: true,
  imports: [OutlineButtonComponent, FullButtonComponent],
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.css']
})
export class DeleteConfirmationComponent {
  @Input() message: string = 'Are you sure you want to delete this item?';
  @Input() useBackdrop: boolean = true;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() { 
    this.confirm.emit(); 
  }

  onCancel() { 
    this.cancel.emit();
  }  
}
